import { Badge, Grid } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { RouteLabel } from "../Layers/RouteLabelLayer/RouteLabel";
import { View } from "../View";
import clsx from "clsx";
import { memo } from "react";
import { palette } from "../../theme/palette";

const useStyles = makeStyles({
  markerContainer: {
    display: "flex",
    flexDirection: "column",
  },
  container: {
    maxWidth: "86px",
    minWidth: "30px",
    minHeight: "30px",
    background: "white",
    borderRadius: "4px",
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "center",
  },
  arrow: {
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "10px solid white",
  },
  spacing: {
    padding: "2px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
  },
  colorPrimary: {
    backgroundColor: "white",
    color: "black",
  },
});

export const CollectionMarker = memo(({ collections }) => {
  const styles = useStyles();

  const routes = [
    ...new Set(collections.map((collection) => collection.routeCode)),
  ];

  return (
    <View className={styles.markerContainer}>
      <View>
        <Grid container className={styles.container}>
          <Grid
            item
            container
            xs
            className={clsx(styles.spacing)}
            direction={"row"}
          >
            <Badge
              badgeContent={collections.length}
              invisible={collections.length <= 1}
              color={"primary"}
              classes={{ colorPrimary: styles.colorPrimary }}
            >
              <RouteLabel
                routeCode={routes.length === 1 && routes[0]}
                collection={true}
                postcode={collections[0].collectionPostcode}
              />
            </Badge>
          </Grid>
        </Grid>
      </View>
      <View className={styles.arrowContainer}>
        <View className={styles.arrow} />
      </View>
    </View>
  );
});
